import * as React from 'react';
import { Table } from '@teamsnap/teamsnap-ui';
import { useQuery } from '@apollo/client';
import { QUERY } from '../../core/gql/queries/coordinated-divisions';
import { Link } from 'react-router-dom';
import { TEAMSNAP_URL } from '../../core/constants';

export interface Props {
  organizationId: number;
}

const DivisionList: React.FunctionComponent<Props> = ({ organizationId }) => {
  const { data, loading } = useQuery(QUERY, {
    variables: { organizationId: organizationId },
  });

  const divisions = data?.coordinatedDivisions?.map(division =>({
    seasonName: division.season.fullName,
    ...division
  })) || [];

  const renderTable = (divisions, loading: boolean) => {
    const sortByKeys = (element1, element2) => {
      const aString = element1.key.toLowerCase();
      const bString = element2.key.toLowerCase();

      if (aString === bString) {
        return 0;
      } else {
        return aString < bString ? -1 : 1;
      }
    };

    return (
      <Table
        isLoading={loading}
        columns={[
          {
            name: 'name',
            label: 'Division Name',
            isSortable: true,
            sortFn: sortByKeys,
            align: 'left',
            mods: 'u-size5of24',
            render: (col, row) => {
              const { name, linkInfo } = row;
              return <a href={`${TEAMSNAP_URL}/${linkInfo.divisionId}/division_teams`}>{row.name}</a>;
            },
          },
          {
            name: 'seasonName',
            label: 'Season Name',
            isSortable: true,
            sortFn: sortByKeys,
            align: 'left',
            mods: 'u-size7of24',
          },
        ]}
        rows={divisions}
      />
    );
  };

  return (
    <div className="container division-list">

      <div className="page-content-body">
        {renderTable(divisions, loading)}
      </div>
    </div>
  );
};

export default DivisionList;
